import { useAuth } from '~/components/providers/AuthProvider';
import { communities, type CommunityConfig } from '~/constants/communities';

/**
 * Hook to get the current community configuration
 * @returns The current community configuration object or undefined if no community is set
 */
export function useCommunity(): CommunityConfig | undefined {
  const { currentCommunity } = useAuth();
  
  return currentCommunity ? communities[currentCommunity] : undefined;
} 